module.exports = __webpack_public_path__ + "img/autospin_btn.8d157623.png";